import './news.scss';
import Swiper from 'swiper/bundle';

export default () => {
    //Swiper
    const slider = new Swiper('.js-news-slider', {
        speed: 1000,
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
            640: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 22,
            },
        },
    });

    const nextBtn = document.querySelector('.js-news-next')

    nextBtn?.addEventListener('click', function (e) {
        e.preventDefault()
        slider.slideNext()
    })
};
